import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: "90px 24px", maxWidth: 620, margin: "auto", fontFamily: "Manrope, sans-serif" }}>
          <h1 style={{ fontSize: 30 }}>Something went off-grid.</h1>
          <p style={{ color: "#55716f", margin: "14px 0 22px" }}>
            This section hit an unexpected error. Reload the page, or call 310-881-5155 and we will help you directly.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{ background: "#113d40", color: "#fff", border: 0, borderRadius: 9, padding: "13px 20px", fontWeight: 700, cursor: "pointer" }}
          >
            Reload the site
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
